import type { MMapNutritionMenuModel } from 'modules/map/types';

/** Có món và trường vẫn ăn tuần này. `isUsed === false` là không ăn, không hiện. */
export const isShownAbridgedMenu = (doc: MMapNutritionMenuModel | null | undefined): boolean => {
  if (!doc || doc.structuredData?.metadata?.isUsed === false) return false;
  const items = doc.structuredData?.data?.items ?? [];
  return items.some((day) => (day.dishes?.length ?? 0) > 0);
};

const FALLBACK_STATES = ['confirm', 'complete', 'propose'];

/**
 * Ưu tiên đúng tiến độ đang chọn. Tiến độ đó không có bản thì lấy bản đã có
 * (xác nhận, hoàn thành, đề xuất). Tiến độ đang chọn có bản nhưng không ăn thì để trống.
 */
export const pickAbridgedMenu = (
  docs: MMapNutritionMenuModel[] | null | undefined,
  state?: string
): MMapNutritionMenuModel | null => {
  const list = docs ?? [];
  const exact = list.find((doc) => doc.metadata?.v20241121?.state === state);
  if (exact) return isShownAbridgedMenu(exact) ? exact : null;

  const shown = list.filter(isShownAbridgedMenu);
  for (const fallback of FALLBACK_STATES) {
    const found = shown.find((doc) => doc.metadata?.v20241121?.state === fallback);
    if (found) return found;
  }
  return shown[0] ?? null;
};
